/**
 * @generated SignedSource<<0d7a021266876449fd6c9386be935e61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbSharedItemTrackingProvider_itemSearch$data = {
  readonly displayUriRef: string | null;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly item: {
        readonly browseUrl: string | null;
        readonly categoryCode: string | null;
        readonly categoryPath: string | null;
        readonly contemporaryTrackingString: string;
        readonly displayPriceTracking: ReadonlyArray<{
          readonly amountType: string | null;
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
          readonly textType: string | null;
        } | null> | null;
        readonly isAuctionEnabled: boolean | null;
        readonly isNewListing: boolean | null;
        readonly seller: {
          readonly serviceId: string | null;
        } | null;
        readonly serviceId: string | null;
        readonly title: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"shippingCostHelpers_item">;
      } | null;
    } | null;
  } | null> | null;
  readonly pageType: string | null;
  readonly searchTerm: string | null;
  readonly sponsored: {
    readonly items: ReadonlyArray<{
      readonly browseUrl: string | null;
      readonly categoryCode: string | null;
      readonly categoryPath: string | null;
      readonly contemporaryTrackingString: string;
      readonly displayPriceTracking: ReadonlyArray<{
        readonly amountType: string | null;
        readonly convertedAmountList: ReadonlyArray<{
          readonly amount: number | null;
          readonly currency: Currency | null;
        } | null> | null;
        readonly textType: string | null;
      } | null> | null;
      readonly isAuctionEnabled: boolean | null;
      readonly isNewListing: boolean | null;
      readonly seller: {
        readonly serviceId: string | null;
      } | null;
      readonly serviceId: string | null;
      readonly title: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"shippingCostHelpers_item">;
    } | null> | null;
    readonly metadata: ReadonlyArray<{
      readonly clickTrackerLink: string | null;
      readonly impressionTrackerLink: string | null;
      readonly itemId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "SbSharedItemTrackingProvider_itemSearch";
};
export type SbSharedItemTrackingProvider_itemSearch$key = {
  readonly " $data"?: SbSharedItemTrackingProvider_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedItemTrackingProvider_itemSearch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "categoryPath",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "browseUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "categoryCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contemporaryTrackingString",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Seller",
    "kind": "LinkedField",
    "name": "seller",
    "plural": false,
    "selections": [
      (v0/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": "displayPriceTracking",
    "args": [
      {
        "kind": "Variable",
        "name": "isTrade",
        "variableName": "isTrade"
      },
      {
        "kind": "Literal",
        "name": "page",
        "value": "searchAndBrowse"
      },
      {
        "kind": "Variable",
        "name": "priceBookName",
        "variableName": "priceBookName"
      },
      {
        "kind": "Variable",
        "name": "userCountryCode",
        "variableName": "userCountryCode"
      }
    ],
    "concreteType": "ItemDisplayPriceType",
    "kind": "LinkedField",
    "name": "displayPrice",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "kind": "LinkedField",
        "name": "convertedAmountList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textType",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAuctionEnabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isNewListing",
    "storageKey": null
  },
  {
    "kind": "InlineDataFragmentSpread",
    "name": "shippingCostHelpers_item",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vertical",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "kind": "LinkedField",
        "name": "shipmentQuotes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isComplimentary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialAmount",
            "kind": "LinkedField",
            "name": "totalAmount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmounts",
                "kind": "LinkedField",
                "name": "convertedAmounts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "USD",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShipmentServiceMethod",
            "kind": "LinkedField",
            "name": "serviceMethod",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Region",
                "kind": "LinkedField",
                "name": "region",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "regionName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "args": null,
    "argumentDefinitions": ([]/*: any*/)
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedItemTrackingProvider_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchTerm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSearchSponsored",
      "kind": "LinkedField",
      "name": "sponsored",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchSponsoredMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clickTrackerLink",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "impressionTrackerLink",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "76017ff4b96470db7e33c72afcf4e46b";

export default node;
